export default "__VITE_ASSET__BXdUlhbS__"